import React, { Fragment, useEffect, useRef, useState } from 'react'
import { KTSVG } from '../../../_metronic/helpers'
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { billingTypeInitialsForAdd, billingTypeInitialsForUpdate } from './interfaces/billingTypeClass';
import { addBillingTypeAsync, updateBillingTypeAsync, resetSelectedRecordObjectInState } from './billingTypeSlics';
import Select, { StylesConfig } from 'react-select';
import fetchAPI from '../../../common/fetchAPI';
import * as yup from 'yup';
import { Formik } from 'formik';
import { ShowToast } from '../../../common/Toastr';
import { dropDownSelectionStyles, getValueFromResource } from '../../../common/timeLiveFunction';

const BillingTypeForm = (props: any) => {
    const [disabledCount, setDisabledCount] = useState(0)
    const { t, oncloseModal } = props;
    const { maxMenuHeight } = useAppSelector(state => state.globalState);
    const defaultFocusRef = useRef<HTMLInputElement>(null);
    const [currentFieldsData, setCurrentFieldsData] = useState<any>(billingTypeInitialsForAdd);
    const { selectedRecord, billingTypeList, isLoading } = useAppSelector((state) => state.billingType);
    const dispatch = useAppDispatch();
    const [selectedOptionDropDown, setSelectedOptionDropDown] = useState<{ [object: string]: any }>();
    const [billingCategoryArray, SetbillingCategoryArray] = useState<any | ''>([]);

    const getBillingCategoryAsync = async () => {
        const response = await fetchAPI("api/v2/BillingTypes/GetDataSystemBillingCategory", "GET", "", true, "d8667f9b-57fd-4ca8-9496-59cbebb5f944");
        const json = await response.json();
        // json.map((item: any) => {
        //     item.value = item.SystemBillingCategoryId;
        //     item.label = item.BillingCategory;
        //     delete item.SystemBillingCategoryId;
        //     delete item.BillingCategory;
        // });
        const modifiedJSON = json.map((item: any) => ({
            value: item.SystemBillingCategoryId,
            label: item.BillingCategory,
        }));
        SetbillingCategoryArray(modifiedJSON);

        if (Object.keys(selectedRecord).length === 0 && modifiedJSON.length > 0) {
            setSelectedOptionDropDown(modifiedJSON[0]);
            setCurrentFieldsData((prev: any) => ({
                ...prev,
                BillingCategoryId: modifiedJSON[0].value,
            }));
        }
    }

    useEffect(() => {
        let stateItem: any = {}
        if (Object.keys(selectedRecord).length > 0) {
            const tempObj: any = selectedRecord;
            Object.keys(billingTypeInitialsForUpdate).map((item) => {
                return stateItem[item] = tempObj[item];
            })
            stateItem.IsDisabled = stateItem.IsDisabled === "Yes" ? true : false;
            setCurrentFieldsData(stateItem);
            setSelectedOptionDropDown({ value: tempObj.Systembillingcategoryid, label: stateItem.BillingCategory });

        }
        else {
            setCurrentFieldsData(billingTypeInitialsForAdd);
        }
        if (defaultFocusRef.current) {
            defaultFocusRef.current.focus();
        }

        calculatedDisabledValue();
    }, [selectedRecord])


    useEffect(() => {
        getBillingCategoryAsync();
    }, [])

    const handleSubmit = (values: any) => {
        if (Object.keys(selectedRecord).length > 0) {
            dispatch(updateBillingTypeAsync(values))
                .unwrap()
                .then((originalPromiseResult) => {
                    originalPromiseResult.StatusCode === "200" ?
                        ShowToast("Billing Type Updated Successfully", 'Success', "success", "toast-top-right") :
                        ShowToast('error', "Billing Type Updated Failed", "error", "toast-top-right");

                })
                .catch((rejectedValueOrSerializedError) => {
                })
        }
        else {
            dispatch(addBillingTypeAsync(values))
                .unwrap()
                .then((originalPromiseResult) => {
                    originalPromiseResult.StatusCode === "201" ?
                        ShowToast("Billing Type Added Successfully", 'Success', "success", "toast-top-right") :
                        ShowToast('error', "Billing Type Added Failed", "error", "toast-top-right");
                })
                .catch((rejectedValueOrSerializedError) => {
                })
        }
        oncloseModal();

    }
    const handleCloseOnClickEvent = () => {
        dispatch(resetSelectedRecordObjectInState());
    }
    const calculatedDisabledValue = () => {
        if (billingTypeList.length > 0) {
            let index = 0;
            billingTypeList.forEach((value) => {
                if (value.IsDisabled.toString() == 'Yes') {
                    index = index + 1
                }
            });
            setDisabledCount(billingTypeList.length - index);
        }
    }
    return (
        <>
            <Formik
                initialValues={{
                    ...currentFieldsData,
                    BillingCategoryId: selectedOptionDropDown?.value || "",
                }}
                enableReinitialize={true}
                onSubmit={(values, action) => { handleSubmit(values); action.resetForm() }}
                validationSchema={yup.object().shape({
                    BillingType: yup
                        .string()
                        .label('BillingType')
                        .trim()
                        .required
                        // (t('Billing type is required')),
                        (getValueFromResource('Billing type is required',dispatch, t)),
                    BillingCategoryId: yup
                        .string()
                        .required
                        // (t('Billing category is required'))
                        (getValueFromResource('Billing category is required',dispatch, t))

                })}>
                {({ values, handleChange, errors, setFieldTouched, touched, isValid, handleSubmit }) => (
                    <Fragment>
                        <form onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                handleSubmit();
                            }
                        }}>
                            {isLoading ?
                                <div className="col-md-12">
                                    <span className='indicator-progress' style={{ display: 'block' }}>
                                        <span className='spinner-border spinner-border-md ms-2'></span>
                                    </span>
                                </div>
                                : <>
                                    <div className="modal drawer-overlay" style={{ display: 'block' }}>
                                        <div className="modal-dialog">
                                            <div className="modal-content">
                                                <div className="modal-header" style={{ padding: '.6rem .6rem' }}>
                                                    <h5 className="modal-title mainHeading">{Object.keys(selectedRecord).length > 0 ? 
                                                    // t('Update Billing Type') 
                                                    getValueFromResource('Update Billing Type',dispatch, t)  : 
                                                    // t('Add Billing Type')} 
                                                    getValueFromResource('Add Billing Type',dispatch, t) }
                                                     </h5>
                                                    <div
                                                        className="btn btn-icon btn-sm btn-active-secondary ms-2 "
                                                        onClick={oncloseModal}
                                                    >
                                                        <KTSVG
                                                            path="/media/icons/duotune/arrows/arr061.svg"
                                                            className="svg-icon svg-icon-1x"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="modal-body">
                                                    <div className="mb-3">
                                                        <label className="fs-7 fw-normal mb-2">
                                                            {/* {t('Billing Type')} */}
                                                            {getValueFromResource('Billing Type',dispatch, t)}
                                                            </label>
                                                        <input
                                                            type="text"
                                                            className="form-control fs-7 fw-normal"
                                                            id='BillingType'
                                                            name='BillingType'
                                                            value={values.BillingType}
                                                            onChange={handleChange('BillingType')}
                                                            ref={defaultFocusRef}
                                                        />
                                                        <div style={{ paddingRight: 20 }}>
                                                            {touched.BillingType && errors.BillingType &&
                                                                <p className='errorMsg'>{errors.BillingType as string}</p>
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className='mb-3 mt-2'>
                                                        <label className="fs-7 fw-normal mb-2">
                                                            {/* {t('Billing Category')} */}
                                                            {getValueFromResource('Billing Category',dispatch, t)}
                                                            </label>
                                                        <Select
                                                            value={billingCategoryArray.find((option: any) => option.value == values.BillingCategoryId)}
                                                            id="BillingCategoryId"
                                                            name="BillingCategoryId"
                                                            className="basic-single"
                                                            classNamePrefix="select"
                                                            isSearchable={true}
                                                            onChange={(selectedOption) => {
                                                                setSelectedOptionDropDown(selectedOption);
                                                                handleChange({
                                                                    target: {
                                                                        id: "BillingCategoryId",
                                                                        value: selectedOption?.value
                                                                    },
                                                                });
                                                            }}
                                                            options={billingCategoryArray}
                                                            styles={dropDownSelectionStyles}
                                                            maxMenuHeight={maxMenuHeight}

                                                        />
                                                        <div style={{ paddingRight: 20 }}>
                                                            {touched.BillingCategoryId && errors.BillingCategoryId &&
                                                                <p className='errorMsg'>{errors.BillingCategoryId as string}</p>
                                                            }
                                                        </div>

                                                    </div>

                                                    {Object.keys(selectedRecord).length > 0 ? (
                                                        disabledCount !== 1 ? <div className="mb-3" >
                                                            <label className="fs-7 fw-normal mt-2">
                                                                {/* {t('Disabled')} */}
                                                                {getValueFromResource('Disabled',dispatch, t)}
                                                                </label>
                                                            <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                                <input className="form-check-input h-20px w-30px mt-2" type="checkbox" checked={values.IsDisabled} id="IsDisabled"
                                                                    onChange={handleChange('IsDisabled')}
                                                                />
                                                            </div>
                                                        </div> : billingTypeList.find(x => x.AccountBillingTypeId === values.AccountBillingTypeId)?.IsDisabled.toString() === "Yes" && (<div className="mb-3" >
                                                            <label className="fs-7 fw-normal mt-2">
                                                                {/* {t('Disabled')} */}
                                                                {getValueFromResource('Disabled',dispatch, t)}

                                                                </label>
                                                            <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                                <input className="form-check-input h-20px w-30px mt-2" type="checkbox" checked={values.IsDisabled} id="IsDisabled"
                                                                    onChange={handleChange('IsDisabled')}
                                                                />
                                                            </div>
                                                        </div>)
                                                    ) : null}
                                                </div>
                                                <div className="modal-footer" style={{ padding: '.6rem .6rem' }} >
                                                    <button
                                                        type="button"
                                                        className="btn btn-secondary btn-bs-btn-font-weight btn-sm"
                                                        onClick={oncloseModal}
                                                    >
                                                        {/* {t('Cancel')} */}
                                                        {getValueFromResource('Cancel',dispatch, t)}

                                                    </button>
                                                    <button type="button" className="btn btn-primary  btn-bs-btn-font-weight btn-sm" onClick={() => handleSubmit()} disabled={!isValid}>
                                                        {/* {t('Save')} */}
                                                        {getValueFromResource('Save',dispatch, t)}

                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            }
                        </form>
                        {/* <form>
                            <div className='card-body'>
                                {isLoading ?
                                    <div className="col-md-12">
                                        <span className='indicator-progress' style={{ display: 'block' }}>
                                            <span className='spinner-border spinner-border-md ms-2'></span>
                                        </span>
                                    </div>
                                    : <>
                                        <div className='row'>

                                            
                                                <div className="col-md-6 mb-3">
                                                    <label className="form-label">Billing Type</label>
                                                    <input type="text" className="form-control" id='BillingType' value={values.BillingType} name='BillingType'
                                                        onChange={handleChange('BillingType')}
                                                        onBlur={() => setFieldTouched('BillingType')}
                                                    />
                                                    <div style={{ paddingRight: 20 }}>
                                                        {touched.BillingType && errors.BillingType &&
                                                            <p className='errorMsg'>{errors.BillingType as string}</p>
                                                        }
                                                    </div>
                                                </div>

                                                <div className="col-md-6 mb-3">
                                                    <label className="form-label">Billing Category</label>
                                                    <Select
                                                        value={billingCategoryArray.find((option: any) => option.value == values.BillingCategoryId)}
                                                        id="BillingCategoryId"
                                                        className="basic-single"
                                                        classNamePrefix="select"
                                                        isSearchable={true}
                                                        name="BillingCategoryId"
                                                        onBlur={() => setFieldTouched('BillingCategoryId', true)}
                                                        onChange={(selectedOption) => {
                                                            handleChange({
                                                                target: {
                                                                    id: "BillingCategoryId",
                                                                    value: selectedOption?.value
                                                                },
                                                            });
                                                        }}
                                                        options={billingCategoryArray}
                                                        styles={colourStyles}
                                                        
                                                    />
                                                <div style={{ paddingRight: 20}}>
                                                    {touched.BillingCategoryId && errors.BillingCategoryId &&
                                                        <p className='errorMsg'>{errors.BillingCategoryId as string}</p>
                                                    }
                                                </div>
                                                </div>
                                            
                                        </div>
                                        <div className='row'>
                                            <div className="col-md-6 mb-2">
                                                {Object.keys(selectedRecord).length > 0 ? (
                                                    <div className="col-md-12">
                                                        <label className="form-label">Disabled</label>
                                                        <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                            <input className="form-check-input h-20px w-30px" type="checkbox"
                                                                checked={values.IsDisabled} id="IsDisabled"
                                                                onChange={handleChange('IsDisabled')}
                                                            />
                                                        </div>
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                    </>
                                }
                            </div>
                            <div className='card-footer pt-4 '>
                                <div className='d-flex flex-stack float-end'>
                                    <div className='d-flex align-items-center me-2'>
                                        <button
                                            type="button"
                                            className="btn btn-light btn-sm me-2"
                                            id="kt_OffCanvas"
                                            onClick={handleCloseOnClickEvent}
                                        >
                                            Close
                                        </button>

                                        <button type="button" data-kt-element='send' className="btn btn-light-primary btn-sm" onClick={() => handleSubmit()} disabled={!isValid}>
                                            {Object.keys(selectedRecord).length > 0 ? 'Update' : 'Add'} Billing Type
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form> */}
                    </Fragment>
                )}
            </Formik>
        </>
    )

}
const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: '100%', minHeight: '36px', height: '36px', padding: '-1px' }),
}
export default BillingTypeForm